module.exports = __webpack_public_path__ + "img/lxwm.2310b326.png";